import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { Box, Button, Fab, Grid, Paper, Skeleton, Stack, Typography } from '@mui/material'


//import KeyAreaNavBar from "./partials/personalreport/KeyAreaNavBar";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"

import { useReactToPrint } from "react-to-print";

/*
  Using a <style> tag directly in a component is generally not standard practice,
  but it is the most effective way to encapsulate print-only styles within a single
  file modification as requested. The @media print query ensures these styles
  do not affect the on-screen display.
*/
const PrintStyles = () => (
    <style>
        {`
        @media print {
            .pr-about-assessment-print {
                padding: 16px;
                border: 1px solid #ccc;
                background-color: #fff;
                margin-top: 16px;
                page-break-inside: avoid; /* Prevents the component from splitting across pages */
            }

            .pr-about-assessment-print h6 {
                font-family: 'Times New Roman', Times, serif;
                font-size: 14pt;
                font-weight: bold;
                color: #000;
                margin-bottom: 8px;
            }

            .pr-about-assessment-print .pr-content {
                font-family: 'Times New Roman', Times, serif;
                font-size: 12pt;
                color: #000;
                line-height: 1.5;
            }
            
            /* Hide buttons or links in print view */
            .pr-about-assessment-print .pr-print-hide {
                display: none;
            }
        }
        `}
    </style>
);


const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 0 },
    show: {
        opacity: 1, x: 0, y: 0,
        transition: {
            delay: 0.1,
            duration: 0.5,
        }
    }
}

const PersonalReportAboutAssessment = (props) => {
    const { component } = props
    const { ComponentContent } = component
    //const { component } = {Title:"Some custom Text",Description:"Some sort of decently long description. Communicate with your audience.", Button:{Text:"Button Name",URL:"https://www.google.com"}} //props
    //const { settings, PrintView } = props.otherprops
    const { settings, PrintView } = props


    // Render the print-optimized view if PrintView is true
    if (PrintView === true) {
        return (
            <>
                <PrintStyles />
                <div className="pr-about-assessment-print">
                    {ComponentContent && ComponentContent.Header && ComponentContent.Header !== "" && (
                        <Typography variant="h6">{ComponentContent.Header}</Typography>
                    )}
                    {ComponentContent && ComponentContent.Content && ComponentContent.Content !== "" && (
                        <div className="pr-content" dangerouslySetInnerHTML={{ __html: ComponentContent.Content }} />
                    )}
                </div>
            </>
        )
    }

    // Render the original component for screen view
    return (
        <Grid item lg={12} md={12} sm={12} xs={12} justifyContent="center" alignItems="stretch" sx={{}} mt={2}>
            <motion.div variants={motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>
                <Paper elevation={1} sx={{ height: '100%', padding: '20px' }}>
                    <Stack direction="column" gap={2}>

                        {ComponentContent && ComponentContent.Header && ComponentContent.Header !== "" && (<Typography variant="h6">{ComponentContent.Header}</Typography>)}
                        {ComponentContent && ComponentContent.Content && ComponentContent.Content !== "" && (<Typography dangerouslySetInnerHTML={{ __html: ComponentContent.Content }} />)}
                        {/*{component && component.Button && component.Button.Text && component.Button.Text !="" && (<Link style={{ textDecoration: "none", color: "inherit" }} to={component.Button.URL}><Button variant="contained">{component.Button.Text}</Button></Link>)} */}
                    </Stack>
                </Paper>
            </motion.div>
        </Grid>
    )

}
export default PersonalReportAboutAssessment